import React from 'react';
import '../styles/Footer.css'; // You will style the Footer here

const icons = {
    discord: require('../Assets/Website Pack/Logo/Discord.png'),
    steam: require('../Assets/Website Pack/Logo/Steam.png'),
    youtube: require('../Assets/Website Pack/Logo/YouTube.png'),
    bluesky: require('../Assets/Website Pack/Logo/Bluesky.png'),
}
const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-icons">
                <a href="https://discord.com/invite/C9SkYT8BrP" target="_blank" rel="noopener noreferrer">
                    <img src={icons.discord} alt="Twitter" className="footer-icon"/>
                </a>
                <a href="https://youtube.com/@polybeatsgame" target="_blank" rel="noopener noreferrer">
                    <img src={icons.youtube} alt="Twitter" className="footer-icon"/>
                </a>
                <a href="https://store.steampowered.com/app/2734590/Poly_Beats" target="_blank" rel="noopener noreferrer">
                    <img src={icons.steam} alt="Twitter" className="footer-icon"/>
                </a>
                <a href="https://bsky.app/profile/5thstepgames.co.uk" target="_blank" rel="noopener noreferrer">
                    <img src={icons.bluesky} alt="Twitter" className="footer-icon"/>
                </a>
            </div>
        </div>
    );
};

export default Footer;
